import {connect} from 'react-redux';
import CaptainDetail from './CaptainDetail.jsx';
import {
  handleUpdateClicked,
  onHideCancelledEntriesChange,
  onHideArchivedEntriesChange
} from './actions';

const mapStateToProps = state => ({
  captainName: state.admin.captainDetail.captainName,
  captainEmail: state.admin.captainDetail.captainEmail,
  captainAddress1: state.admin.captainDetail.captainAddress1,
  captainAddress2: state.admin.captainDetail.captainAddress2,
  captainCity: state.admin.captainDetail.captainCity,
  captainState: state.admin.captainDetail.captainState,
  captainCountry: state.admin.captainDetail.captainCountry,
  captainZip: state.admin.captainDetail.captainZip,
  captainPhoneNumber: state.admin.captainDetail.captainPhoneNumber,
  tournamentEntries: state.admin.captainDetail.tournaments,
  loadingTournaments: state.admin.captainDetail.loadingTournaments,
  showSearchLink: !!state.admin.home.searchValue,
  balance: state.admin.captainDetail.balance,
  hideCancelledEntries: state.admin.captainDetail.hideCancelledEntries,
  hideArchivedEntries: state.admin.captainDetail.hideArchivedEntries
});

const mapDispatchToProps = dispatch => ({
  onUpdateClicked: () => dispatch(handleUpdateClicked()),
  onHideCancelledEntriesChange: (newValue) => dispatch(onHideCancelledEntriesChange(newValue)),
  onHideArchivedEntriesChange: (newValue) => dispatch(onHideArchivedEntriesChange(newValue))
});

export default connect(mapStateToProps, mapDispatchToProps)(CaptainDetail);



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainDetailContainer.jsx